export default "__VITE_ASSET__Diqu10PI__"